export enum CampaignType {
  Default = 0,
  Programmatic = 1,
  ProgrammaticConnect = 2,
  AutoPilot = 3,
  SinglePosting = 4,
}
